import { useQuery } from '@tanstack/react-query';

import httpClient from './httpClient';
import { useSelectedSubaccountId } from './selectedSubaccount';

const getQueryFunction = ({ queryKey: [endpoint, params] }) => new Promise((resolve, reject) => {
  httpClient.get(`${endpoint}/`, { params })
    .then(({ data }) => {
      resolve(data);
    })
    .catch((e) => {
      reject(e);
    });
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const GetList = (endpoint, params, config) => {
  // subaccountId is part of the cache key so different accounts never share a
  // cache entry (the request itself is scoped by the httpClient interceptor).
  const subaccountId = useSelectedSubaccountId();

  return useQuery({
    queryKey: [endpoint, params, subaccountId],
    queryFn: getQueryFunction,
    // Defaults before ...config so callers can override the cadence/retries.
    refetchInterval: 30 * 1000,
    retry: 1,
    ...config,
    // After ...config: the cross-account guard must not be overridable. Keep
    // previous data across pagination (smooth page changes) but NOT across an
    // account switch, so one account's list never flashes under another.
    placeholderData: (prev, prevQuery) =>
      (prevQuery?.queryKey?.[2] === subaccountId ? prev : undefined),
  });
};

export default GetList;
